//@flow
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import RecommendedCarousel from 'components/organisms/recommendedCarousel';
import RecommendedMobileCarousel from 'components/organisms/recommendedMobileCarousel';
import type { RecommendedScreenType } from 'types/common';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import { RouteUtil } from 'utils/RouteUtil';
import './styles.scss';

type Props = {
  data: Array<RecommendedScreenType>,
};

const RelatedJobRoles = (props: Props) => {
  const { data, breadcrumbList } = props;
  const { height } = useViewport();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const goToCareersDetails = urlSlug => {
    const locationPath = props.location;
    RouteUtil.setRouteChange(
      props,
      `/careers/${urlSlug}`,
      locationPath.hash,
      locationPath.pathname
    );
    window.location.reload();
  };

  return (
    <div style={{ height }} id={'related-roles'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <RecommendedCarousel
            recommendedList={data.data}
            fetchTitle={
              <h2>
                Related <br />
                Roles
              </h2>
            }
            displayHeader={false}
            isDefinedRoute={true}
            onClick={data => goToCareersDetails(data.urlSlug)}
            breadcrumbList={breadcrumbList}
            type="career"
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <RecommendedMobileCarousel
          recommendedList={data.data}
          fetchTitle={
            <>
              <h3 className={'relatedRoles-heading'}>Related Roles</h3>
              <p className={'relatedRoles-description'}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor.
              </p>
            </>
          }
          isDisplayLocationIcon={false}
          isDefinedRoute={true}
          toggleTag={true}
          type="career"
          onClick={data => goToCareersDetails(data.urlSlug)}
          breadcrumbList={breadcrumbList}
        />
      )}
    </div>
  );
};
export default withRouter(RelatedJobRoles);
